import React, { FC, useEffect, useState } from 'react';

import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalFooter
} from '@epoch-ui/components/Modal/modal';
import { Button } from '@epoch-ui/components/Button';
import { Icon } from '@epoch-ui/components/Icon';
import { DESCRIPTION_LENGTH } from 'constants/ai-prompt.constants';

import ShortTextIcon from '../icons/ShortTextIcon';
import MediumTextIcon from '../icons/ShortTextIcon copy';
import LongTextIcon from '../icons/LongTextIcon';
import AIBetaPill from '../../AIBetaPill';

import EventDescriptionAISteps from './EventDescriptionAISteps';

interface EventDescriptionLengthProps extends React.ComponentProps<typeof Modal> {
  handleSubmit: (type: string) => void;
  selectedLength?: string;
  handleBack: () => void;
}

const ICON_MAP = {
  [DESCRIPTION_LENGTH.SHORT]: <ShortTextIcon />,
  [DESCRIPTION_LENGTH.MEDIUM]: <MediumTextIcon />,
  [DESCRIPTION_LENGTH.LONG]: <LongTextIcon />
};

/**
 * AI modal prompts for Event description.
 * step 3: Select length of description
 * @param param0
 * @returns
 */
const EventDescriptionLength: FC<React.PropsWithChildren<EventDescriptionLengthProps>> = ({
  handleSubmit,
  selectedLength,
  handleBack,
  open: isOpen,
  onOpenChange: onRequestClose,
  ...props
}) => {
  const [length, setLength] = useState<string>();

  useEffect(() => {
    setLength(selectedLength || '');
  }, [selectedLength]);

  return (
    <Modal open={isOpen} onOpenChange={(open) => !open && onRequestClose?.(false)} {...props}>
      <ModalContent size="md">
        <ModalHeader>
          <div className="tw-flex tw-flex-col tw-items-start">
            <AIBetaPill />
            <ModalTitle>Suggest description</ModalTitle>
          </div>
        </ModalHeader>

        <div className="tw-text-sm tw-font-medium tw-text-dark-black">
          How long should the description be?
        </div>

        <div className="tw-pr-15 tw-mt-4 tw-flex tw-flex-row tw-flex-wrap tw-gap-2 sm:tw-flex-nowrap">
          {Object.values(DESCRIPTION_LENGTH).map((val, idx) => {
            const selected = val === length;

            return (
              <div
                className={`tw-cursor-pointer tw-rounded-lg tw-border-[1.5px] tw-border-solid ${
                  selected ? 'tw-border-primary-blue' : 'tw-border-border-grey'
                } tw-p-4 `}
                key={`description_length-${idx}`}
                onClick={(): void => {
                  setLength(val);
                }}
              >
                {ICON_MAP[val]}
                <div
                  className={`tw-mt-4 tw-font-medium ${
                    selected ? 'tw-text-dark-black' : 'tw-text-primary-grey'
                  }`}
                >
                  {val}
                </div>
              </div>
            );
          })}
        </div>

        <ModalFooter className="tw-justify-between sm:tw-justify-between">
          <EventDescriptionAISteps step={3} />
          <div className="tw-flex tw-gap-2">
            <Button
              variant="secondary"
              onClick={(): void => {
                handleBack();
              }}
            >
              Back
            </Button>
            <Button
              variant="primary"
              disabled={!length}
              onClick={(): void => {
                handleSubmit(length!);
              }}
            >
              Next
              <Icon name="arrow-right" size={16} className="tw-ml-2" />
            </Button>
          </div>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EventDescriptionLength;
